// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__3PdkH","Open":"Sidebar_Open__2Zr9Y","Close":"Sidebar_Close__3CtEK","Logo":"Sidebar_Logo__3JGp0"};